import { useECommerceProduct } from "@omni/components/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { cn } from "@omni/utils/styles";

import { TieredPriceComponent } from "./tieredPrice.component";

type Props = {
    className?: string;
};

const TieredPrices = ({ className }: Props) => {
    const { t } = useGranite();

    const { tieredPrices } = useECommerceProduct();

    if (!tieredPrices.length) return null;

    return (
        <div className={cn(className)}>
            <div
                className={cn(
                    "tw:font-gravity tw:uppercase tw:text-3xl tw:text-white tw:bg-secondary tw:text-center tw:py-4 tw:rounded-t-xl"
                )}
            >
                {t("product.eCommerce.price.tieredPrice.description")}
            </div>
            <div>
                {tieredPrices.map((price, index) => (
                    <TieredPriceComponent
                        key={index}
                        price={price}
                    />
                ))}
            </div>
        </div>
    );
};

export { TieredPrices };
